// Synthesizes a short two-tone chime with the Web Audio API instead of
// bundling an audio file, so a new chat message gets an audible cue with
// no binary asset to license or ship.
export const playChatNotificationSound = () => {
  try {
    const AudioContextClass =
      window.AudioContext || (window as any).webkitAudioContext;
    const ctx = new AudioContextClass();
    const now = ctx.currentTime;

    const playTone = (frequency: number, start: number, duration: number) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency, now + start);
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(0.2, now + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + duration);
      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start(now + start);
      oscillator.stop(now + start + duration);
    };

    playTone(880, 0, 0.15);
    playTone(1175, 0.12, 0.2);

    setTimeout(() => ctx.close(), 500);
  } catch (error) {
    console.log("playChatNotificationSound error: ", error);
  }
};
